import {
  CANCEL,
  DONE,
  FETCH_CURRENTLY_LISTED_FULFILLED,
  FETCH_CURRENTLY_LISTED_PENDING,
  FETCH_CURRENTLY_LISTED_REJECTED,
  FETCH_CURRENTLY_LISTED_ABORT,
} from '../constants';

export const defaultState = {
  fetched: false,
  fetching: false,
  listingsBySection: {},
};

export default function currListedReduce(state = defaultState, action) {
  switch (action.type) {
    case DONE:
    case CANCEL:
      return {
        ...defaultState,
      };

    case FETCH_CURRENTLY_LISTED_PENDING:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_CURRENTLY_LISTED_FULFILLED: {
      const { body } = action.payload || {};
      const { CurrentlyPostedPriceData } = body || {};
      const listingsBySection = { ...state.listingsBySection };

      CurrentlyPostedPriceData.forEach((postedSection) => {
        listingsBySection[postedSection.Section] = listingsBySection[postedSection.Section] || [];
        listingsBySection[postedSection.Section].push(postedSection);
      });

      return {
        ...state,
        listingsBySection,
        fetched: true,
        fetching: false,
      };
    }

    case FETCH_CURRENTLY_LISTED_REJECTED:
    case FETCH_CURRENTLY_LISTED_ABORT:
      return {
        ...state,
        error: action.payload,
        fetched: true,
        fetching: false,
      };

    default:
      return state;
  }
}
